import * as yup from 'yup';

export const productSchema = yup.object().shape({
  title: yup.string().required().typeError('Give a name to your offer'),
  products: yup.array().min(1, 'You must add at least one product to your offer'),
  setting_call_to_action: yup.string().nullable().required('Required field')
});
